// The store's theme colour (website editor -> Design). The stylesheet draws buttons, links, badges, the
// announcement bar and the footer from --green and its shades, so setting these recolours the whole store.
const HEX = /^#[0-9a-f]{6}$/i;

// Blends a #rrggbb colour towards another; weight 0 keeps the colour, 1 gives the other
function mix(color, other, weight) {
    const channel = (hex, i) => parseInt(hex.slice(1 + i * 2, 3 + i * 2), 16);
    return (
        "#" +
        [0, 1, 2]
            .map((i) => Math.round(channel(color, i) * (1 - weight) + channel(other, i) * weight).toString(16).padStart(2, "0"))
            .join("")
    );
}

// How bright a #rrggbb colour looks, 0 (black) to 1 (white)
function luminance(color) {
    const lin = (i) => {
        const c = parseInt(color.slice(1 + i * 2, 3 + i * 2), 16) / 255;
        return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
    };
    return 0.2126 * lin(0) + 0.7152 * lin(1) + 0.0722 * lin(2);
}

// gradient: [from, to] for designs with a two-colour look (pets: bright yellow); solid colour otherwise.
// A light colour (a bright yellow) cannot carry white text or be read as text on white, so it fills buttons and
// highlights with dark text on them (--on-brand), and text, links and borders use a near-black shade of it.
export function applyTheme(color, gradient) {
    if (!HEX.test(color || "")) return;
    const root = document.documentElement.style;
    const light = luminance(color) > 0.6;
    const base = light ? mix(color, "#000000", 0.86) : color;
    root.setProperty("--green", base);
    root.setProperty("--brand-fill", gradient ? `linear-gradient(135deg, ${gradient[0]}, ${gradient[1]})` : color);
    root.setProperty("--brand-2", gradient && HEX.test(gradient[1] || "") ? gradient[1] : base); // second colour of the animated buttons and sparkles (fashion.css)
    root.setProperty("--on-brand", light ? mix(color, "#000000", 0.88) : "#fff");
    root.setProperty("--green-dark", mix(base, "#000000", 0.4));
    root.setProperty("--green-mid", light ? mix(color, "#000000", 0.7) : mix(color, "#ffffff", 0.18));
    root.setProperty("--green-soft", mix(color, "#ffffff", light ? 0.75 : 0.88));
    root.setProperty("--ink", mix(base, "#000000", light ? 0.3 : 0.62)); // headings and body text: a very dark shade of the colour
    // The phone's browser bar takes the same colour
    let meta = document.querySelector('meta[name="theme-color"]');
    if (!meta) {
        meta = document.createElement("meta");
        meta.name = "theme-color";
        document.head.appendChild(meta);
    }
    meta.content = color;
}
